import script from "./MasterClass.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterClass.vue?vue&type=script&setup=true&lang=js"

import "./MasterClass.vue?vue&type=style&index=0&id=6b8cf386&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8cf386"]])

export default __exports__